
export default {
  settings: {
    endpointsSectionTitle: 'Pontos finais de serviço (URI ou URL completa)',
    language: 'Idioma',
    appLocale: 'Localização da aplicação',
    unit: 'Unidade',
    areaUnit: 'Unidade de área',
    saveToLocalStorage: 'Salvar no meu navegador',
    routeInstructions: 'Instruções de rota',
    alternativeIsochroneColors: 'Cores de isócronos alternativas',
    distanceMarkers: 'Marcadores de distância',
    elevationProfile: 'Perfil de altitude',
    mapSettings: 'Visualização do mapa e informações extras',
    defaultMapSettingsRestored: 'Configurações padrão do mapa restauradas e salvas',
    endpointsTitle: {
      directions: 'Direções',
      isochrones: 'Isócronos',
      geocodeSearch: 'Busca por geocódigo',
      autocomplete: 'Sugestões para geocódigo',
      pois: 'Pontos de interesse',
      reverseGeocode: 'Geocódigo reverso'
    },
    apiKey: 'chave da API',
    customApiKey: 'Chave da API personalizada',
    apiBaseUrl: 'URL base da API',
    invalidSettingsValue: 'Valor(es) de configuração inválido(s). Por favor, verifique os campos ou restaure os valores padrão',
    restoreDefaults: 'Restaurar padrões',
    advanced: 'Avançado',
    mapSettingsSaved: 'Configurações salvas',
    alwaysFitBounds: 'Sempre ajustar o enquadramento dos elementos no mapa quando a rota mudar',
    routeExtraInfo: 'Informações adicionais da rota',
    mapViewOptions: 'Opções de visualização do mapa',
    advancedSettingsWarning: 'Não altere as configurações abaixo se você não souber o que está fazendo!',
    customOverlayerTileProviderUrl: 'URL de provedor de camada personalizada',
    customTileProviderUrl: 'URL do provedor personalizados de imagens do mapa (tiles provider)',
    defaultTilesProvider: 'Provedor padrão de imagens do mapa (tiles provider)',
    customTileProviderUrlHint: 'https://domain.tld/path/{z}/{x}/{y}.ext?chaveOpcional=valor',
    prioritizeSearchingForNearbyPlaces: 'Priorizar a busca de locais próximos',
    defaultProfile: 'Perfil padrão',
    compressDataUrlSegment: 'Comprimir o segmento da URL depois de /data/',
    autoFitHighlightedBounds: 'Automaticamente enquadrar elemento(s) selecionad(o)',
    reloadToApplyLanguageChangeTitle: 'É necessário recarregar a aplicação',
    reloadToApplyLanguageChangeText: 'Para que a mudança de idioma seja totalmente aplicada é necessário recarregar a aplicação. Recarregar agora?',
    resetShownOnceTooltips: 'Exibir dicas quando a aplicação é carregada',
    convertStopAfterRouteEndingToDestination: 'Parada adicionada após o fim da rota vira destino final',
    skipAllSegments: 'Rota reta para todos os segmentos',
    useStopOptimization: 'Otimizar a rota quando uma parada é criada via arrastar/saltar'
  }
}
